/**
 * @author Nihar<nihar.baishya@314ecorp.com>
 * @description React Hook useUpdateWriteOffReason
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';

import api from 'client/index';
import AppEvents from '@veritable/common/utils/appEvents';
import QUERY_KEYS from 'app-constants/queryKeys';

/**
 * Mutate for update write off reason
 *
 */
interface IProps {
	model: EntitySettings.IWriteOffReasonPatchRequest;
}
const useUpdateWriteOffReason = (): UseMutationResult<unknown, IAxiosError, IProps, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({ model }) => {
			await api.WriteOffReasonApi.patchWriteOffReason(model);
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			setTimeout(() => {
				queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.writeOffReasons] });
			});
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useUpdateWriteOffReason;
